import { render, staticRenderFns } from "./XmSelect.vue?vue&type=template&id=1d32bd0f&scoped=true"
import script from "./XmSelect.vue?vue&type=script&lang=js"
export * from "./XmSelect.vue?vue&type=script&lang=js"
import style0 from "./XmSelect.vue?vue&type=style&index=0&id=1d32bd0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d32bd0f",
  null
  
)

export default component.exports